import { render, staticRenderFns } from "./SelectLandType.vue?vue&type=template&id=8396f3ec"
import script from "./SelectLandType.vue?vue&type=script&lang=js"
export * from "./SelectLandType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports